



















































































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import Stats from '@modules/ui/components/Stats'
import UiPannel from '@superUI/Pannels/Pannel'
import UiPannelHead from '@superUI/Pannels/PannelHead'
import UiPannelBody from '@superUI/Pannels/PannelBody'
import Trigger from '@modules/ui/triggers/Trigger'
import FlagsAndTags from '@superUI/FlagsAndTags'

settings =
  name: 'ActivationShow'
  components: { SuperContainerView, Back, Stats, UiPannel, UiPannelHead, UiPannelBody, Trigger, FlagsAndTags }
  resources:
    item:
      resourceName: 'activation'
      slug: 'activations/:activationId'
  vue:
    props: ['activationId']
    data: ->
      openPanel: null

      deleteModal:
        modalOptions:
          title: 'Delete this activation'
          button:
            label: 'Delete'
            type: 'danger'

      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      deleteTriggerResource: ->
        { key: 'item', triggerName: 'delete', component: this }

      memberNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_super_note', component: this }

      publicTagTriggerResource: ->
        { key: 'item', triggerName: 'add_public_tag', component: this }
      privateTagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_tag', component: this }
      untagTriggerResource: ->
        { key: 'item', triggerName: 'untag', component: this }
      privateStatusFlagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_status_flag', component: this }
      unflagTriggerResource: ->
        { key: 'item', triggerName: 'unflag', component: this }

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload

    methods:
      hiOpenPannel: (id) ->
        if @openPanel != id
          @openPanel = id
        else
          @openPanel = null

      onItemDelete: -> @$router.push({ name: 'ActivationListPage' })

      onItemAddMemberNote: -> @fetch('item')
      onItemAddSuperNote: -> @fetch('item')
      onItemAddPublicTag: -> @fetch('item')
      onItemAddPrivateTag: -> @fetch('item')
      onItemUntag: -> @fetch('item')
      onItemAddPrivateStatusFlag: -> @fetch('item')
      onItemUnflag: -> @fetch('item')

export default VueOptions.vue settings
